<template>
  <div class="sticky">
    <div class="sidebar-search-filters"
         v-if="availableProductCategories.length && availableProductGroups.length">
      <div v-if="availableProductGroups.length > 1" class="product-group mb-4">
        <p class="label">{{$t('common.filterProductGroup')}}</p>
        <div class="available-items">
          <div v-for="(group, i) in availableProductGroups" :key="`product-group-${i}`"
               class="mb-1 category"
               :class="{'selected': group.selected, 'pointer': availableProductGroups.length > 1}"
               @click="handleProductGroup(group)">
            <span v-html="group.name"></span>
            <span class="pl-1">{{group.quantity}}</span>
          </div>
        </div>
      </div>
      <div v-if="availableProductCategories.length > 1" class="product-category mb-4">
        <p class="label">{{$t('common.filterProductCategory')}}</p>
        <div class="available-items">
          <div v-for="(category, i) in availableProductCategories" :key="`product-category-${i}`"
               class="mb-1 category"
               :class="{'selected': category.selected, 'pointer': availableProductCategories.length > 1}"
               @click="handleProductCategory(category)">
            <span v-html="category.name"></span>
            <span class="pl-1">{{category.quantity}}</span>
          </div>
        </div>
      </div>
      <div v-if="availableMaterialTypes.length > 1" class="material-type mb-4">
        <p class="label">{{$t('common.filterMaterialType')}}</p>
        <div class="available-types">
          <div v-for="(type, i) in availableMaterialTypes" :key="`material-type-${i}`"
               class="mb-3 material-type"
               :class="{'bold': type.term_id === selectedMaterialType, 'pointer': availableMaterialTypes.length > 1}"
               @click="handleMaterialType(type)">
            <span v-html="type.name"></span>
            <span class="text-secondary pl-1">{{type.quantity}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    materialTypes: null,
    productCategories: null,
    productGroups: null,
  },
  data() {
    return {
      availableMaterialTypes: [],
      selectedMaterialType: [],
      availableProductCategories: [],
      availableProductGroups: [],
    };
  },
  mounted() {
    if (this.materialTypes) {
      if (!this.isMaterialTypesIncludesDuplicatedNames(this.materialTypes)) {
        this.availableMaterialTypes = this.materialTypes;
        this.availableMaterialTypes.forEach((item) => {
          // eslint-disable-next-line
          item.selected = false;
        });
      } else {
        this.availableMaterialTypes = [];
      }
    }
    // eslint-disable-next-line
    if (this.productCategories) {
      this.availableProductCategories = this.productCategories;
      this.availableProductCategories.forEach((item) => {
        // eslint-disable-next-line
        item.selected = false;
      });
    }
    // eslint-disable-next-line
    if (this.productGroups) {
      this.availableProductGroups = this.productGroups;
      this.availableProductGroups.forEach((item) => {
        // eslint-disable-next-line
        item.selected = false;
      });
    }
  },
  methods: {
    handleMaterialType(type) {
      if (this.availableMaterialTypes.length > 1) {
        if (this.selectedMaterialType === type.term_id) {
          this.deselectMaterialType(type);
        } else {
          this.selectMaterialType(type);
        }
      }
    },
    selectMaterialType(type) {
      this.selectedMaterialType = type.term_id;
      this.$root.$emit('materialTypeSelected', type);
    },
    deselectMaterialType(type) {
      this.selectedMaterialType = null;
      this.$root.$emit('materialTypeDeselected', type);
    },
    handleProductCategory(category) {
      if (this.availableProductCategories.length > 1) {
        if (!category.selected) {
          this.selectProductCategory(category);
        } else {
          this.deselectProductCategory(category);
        }
      }
    },
    selectProductCategory(category) {
      this.availableProductCategories = Object.entries(this.availableProductCategories).map(
        // eslint-disable-next-line
        ([key, val]) => {
          if (val.term_id === category.term_id) {
            // eslint-disable-next-line
            val.selected = true;
          }
          return val;
        },
      );
      this.$root.$emit('productCategorySelected', category);
    },
    deselectProductCategory(category) {
      this.availableProductCategories = Object.entries(this.availableProductCategories).map(
        // eslint-disable-next-line
        ([key, val]) => {
          if (val.term_id === category.term_id) {
            // eslint-disable-next-line
            val.selected = false;
          }
          return val;
        },
      );
      this.$root.$emit('productCategoryDeselected', category);
    },
    handleProductGroup(group) {
      if (this.availableProductGroups.length > 1) {
        if (!group.selected) {
          this.selectProductGroup(group);
        } else {
          this.deselectProductGroup(group);
        }
      }
    },
    selectProductGroup(group) {
      this.availableProductGroups = Object.entries(this.availableProductGroups).map(
        // eslint-disable-next-line
        ([key, val]) => {
          if (val.term_id === group.term_id) {
            // eslint-disable-next-line
            val.selected = true;
          }
          return val;
        },
      );
      this.$root.$emit('productGroupSelected', group);
    },
    deselectProductGroup(group) {
      this.availableProductGroups = Object.entries(this.availableProductGroups).map(
        // eslint-disable-next-line
        ([key, val]) => {
          if (val.term_id === group.term_id) {
            // eslint-disable-next-line
            val.selected = false;
          }
          return val;
        },
      );
      this.$root.$emit('productGroupDeselected', group);
    },
    isMaterialTypesIncludesDuplicatedNames(materialTypes) {
      const names = materialTypes.map((type) => type.name);
      return new Set(names).size !== names.length;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/common.scss';
.sidebar-search-filters {
  font-size: 13px;
  .label {
    color: $secondary;
    text-transform: uppercase;
    font-size: 11px;
    margin-bottom: .5rem;
  }
  .selected {
    color: #fff;
  }
  .available-items {
    .category {
      background: $light-grey;
      padding: .8rem 1.4rem;
      text-transform: uppercase;
      border-radius: 7px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  .available-types {
    .material-type {
      display: flex;
      justify-content: space-between;
      align-items: center;

      text-transform: uppercase;
      @include media-breakpoint-up(xl) {
        font-size: 16px;
        max-width: 90%;
      }
    }
  }
}
.product-category {
  .selected {
    background: $secondary!important;
  }
}
.product-group {
  .selected {
    background: $primary!important;
  }
}
.material-type {
  .available-types {
    .type {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: .4rem 0;
      img {
        max-width: 13px;
        transform: rotate(90deg);
        margin-right: 2rem;
      }
    }
    .available-materials {
      margin-bottom: .5rem;
      padding-bottom: .7rem;
      border-bottom: 1px solid $secondary;
      .material {
        padding: .3rem 0 .3rem 1.5rem;
      }
      .no-materials {
        color: #909090;
      }
    }
  }
}
@include media-breakpoint-down(lg) {
  .sidebar-search-filters {
    font-size: 11px;
    .label {
      font-size: 9px;
    }
  }
}
</style>
